/* el-how-to.js — sections/el-how-to.liquid
   Product tabs: one guide open at a time; arrow keys move between tabs (WAI-ARIA tabs pattern).
   #anchor or ?product=anchor opens that guide; picking a tab updates the hash so the link can be shared. */
(function () {
  'use strict';

  function select(root, tab, focus, updateHash) {
    root.querySelectorAll('[data-el-how-to-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = !on;
        /* stop a video that is playing in a tab being closed */
        if (!on) panel.querySelectorAll('video').forEach(function (v) { v.pause(); });
      }
    });
    if (focus) tab.focus();
    var row = tab.parentElement;
    if (row.scrollWidth > row.clientWidth) {
      row.scrollTo({ left: tab.offsetLeft - row.offsetLeft - 16, behavior: 'smooth' });
    }
    if (updateHash && tab.dataset.anchor && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + tab.dataset.anchor);
    }
  }

  function fromUrl() {
    var key = (window.location.hash || '').replace('#', '');
    if (!key) {
      var m = window.location.search.match(/[?&]product=([^&]+)/);
      if (m) key = decodeURIComponent(m[1]);
    }
    if (!key) return;
    key = key.toLowerCase();
    document.querySelectorAll('[data-el-how-to]').forEach(function (root) {
      root.querySelectorAll('[data-el-how-to-tab]').forEach(function (t) {
        if (t.dataset.anchor && t.dataset.anchor === key) select(root, t, false, false);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-el-how-to-tab]');
    if (!tab) return;
    select(tab.closest('[data-el-how-to]'), tab, false, true);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('[data-el-how-to-tab]');
    if (!tab) return;
    var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[data-el-how-to-tab]'));
    var i = tabs.indexOf(tab), next = null;
    if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
    else if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (event.key === 'Home') next = tabs[0];
    else if (event.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;
    event.preventDefault();
    select(tab.closest('[data-el-how-to]'), next, true, true);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromUrl);
  else fromUrl();
  window.addEventListener('hashchange', fromUrl);
})();
